// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3SBgk","Brand":"Layout_Brand__3GynO","Content":"Layout_Content__2WLOk"};